import { render } from "./AvatarPreview.vue?vue&type=template&id=7ba1d95c"
import script from "./AvatarPreview.vue?vue&type=script&lang=js"
export * from "./AvatarPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__